export interface SSOFieldSchema {
  key: string;
  value: string | boolean | Record<string, string>;
  label: string;
  type: 'text' | 'checkbox' | 'json';
  sortlevel: number;
}

export interface SSOConfiguration {
  configuration_name: string;
  fields: SSOFieldSchema[];
}

export interface SSOConfigurationsResponse {
  configurations: SSOConfiguration[];
}

export interface SSOConfigurationCreateResponse {
  message: string;
  configurations: SSOConfiguration[];
}

export interface SSOConfigurationUpdateResponse {
  message: string;
  configurations: SSOConfiguration[];
}

export interface SSOConfigurationDeleteResponse {
  message: string;
  configurations: SSOConfiguration[];
}

export interface SSOConfigurationUpdateRequest {
  configuration_name: string;
  provider_type?: string;
  provider?: string;
  authorize_endpoint?: string;
  exchange_token_endpoint?: string;
  user_info_endpoint?: string;
  redirect_uri?: string;
  client_id?: string;
  client_secret?: string;
  grant_type?: string;
  response_type?: string;
  response_mode?: string;
  scope?: string;
  code_challenge_method?: string;
  logo?: string;
  ui_login_button_enabled?: boolean;
  allow_sso_user_provision?: boolean;
  user_attributes_mapping?: Record<string, string>;
}

export const PROVIDER_TYPE_OPTIONS = [
  { value: 'pkce', label: 'PKCE (Browser-based SSO)' },
  { value: 'authorization_code', label: 'Authorization Code' },
  { value: 'client_credentials', label: 'Client Credentials (M2M)' },
  { value: 'jwt_bearer_cc', label: 'JWT Bearer Client Credentials' }
];

/** Fields that are always required regardless of provider_type */
const ALWAYS_REQUIRED: string[] = [
  'configuration_name',
  'provider_type',
  'provider',
  'exchange_token_endpoint',
  'grant_type',
  'scope'
];

/** Additional required fields per provider_type */
const PROVIDER_REQUIRED: Record<string, string[]> = {
  pkce: [
    'authorize_endpoint',
    'user_info_endpoint',
    'redirect_uri',
    'client_id',
    'client_secret',
    'response_type',
    'response_mode',
    'code_challenge_method'
  ],
  authorization_code: [
    'authorize_endpoint',
    'user_info_endpoint',
    'redirect_uri',
    'client_id',
    'client_secret',
    'response_type'
  ],
  client_credentials: [],
  jwt_bearer_cc: []
};

/** Returns the set of required field keys for a given provider_type */
export function getRequiredFields(providerType: string): Set<string> {
  const extra = PROVIDER_REQUIRED[providerType] || [];
  return new Set([...ALWAYS_REQUIRED, ...extra]);
}
